import {Component, inject, isDevMode, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {Router} from '@angular/router';
import {CatalogStore} from '@store/catalog.store';
import {StorageService} from '@services/storage.service';
import {SessionStore} from '@store/session.store';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './splash.html',
  styleUrl: './splash.scss'
})
export class Splash implements OnInit {

  tempName = isDevMode() ? 'invitado' : ''
  tableUuid: string | null = null;
  errorMessage: string | null = null;


  protected readonly store = inject(CatalogStore);
  protected readonly sessionStore = inject(SessionStore);
  protected readonly isDev = isDevMode();
  private readonly storage = inject(StorageService);
  private readonly router = inject(Router);


  ngOnInit() {

    const uid = this.sessionStore.tableUID() || localStorage.getItem('table_uid');
    if (uid) {
      this.tableUuid = uid;

      this.sessionStore.setTable(uid.toLowerCase());
      this.errorMessage = null;
    } else if (!this.tableUuid) {
      this.errorMessage = 'Por favor, escanea el código QR de tu mesa.';
    }
  }

  startSession() {
    if (!this.tempName.trim() || !this.tableUuid) return;
    try {
      this.storage.clear();
      const uuidSeguro = this.tableUuid.toLowerCase();
      this.sessionStore.setTable(uuidSeguro);
      this.sessionStore.setCustomerName(this.tempName.trim());
      this.sessionStore.updateCustomerSessionName(this.tempName.trim());

      this.sessionStore.initializeSession({
        onSuccess: () => this.router.navigate(['/standard/categories'], {replaceUrl: true}),
        onError: () => this.errorMessage = 'No pudimos conectar. Intenta de nuevo.'
      });
    } catch (error) {
    }
  }


  simulateScan() {
    if (this.isDev) {
      this.tableUuid = 'EF17A81B-9652-4BB4-9AB7-7E939CA15620';
      this.errorMessage = null;
    }

  }
}
